import { useApi } from 'api'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons'
import { Alert, Button, Modal } from 'react-bootstrap'
import { Invoice } from 'types'
import { useState } from 'react'
import { AxiosError } from 'openapi-client-axios'

export default function FinalizeButton(props: {
  invoice: Invoice
  onFinalize?: Function
}) {
  const { invoice, onFinalize } = props
  const [show, setShow] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>()

  const api = useApi()

  const finalizeInvoice = async () => {
    try {
      invoice.finalized = true
      const { data } = await api.put(`/invoices/${invoice.id}`, invoice)
      onFinalize && (await onFinalize(data))
      setShow(false)
    } catch (e: any) {
      const err = e as AxiosError<any>
      setErrorMessage(
        (err.response?.data?.message as string) ||
          `An error occured: ${err.response?.status} - ${err.response?.statusText}`
      )
    }
  }
  const handleClose = () => {
    setShow(false)
    setErrorMessage(undefined)
  }
  const handleShow = () => setShow(true)

  return (
    <>
      <Button
        variant={invoice.finalized ? 'outline-secondary' : 'success'}
        onClick={handleShow}
        disabled={!!invoice.finalized}
      >
        <FontAwesomeIcon icon={faCircleCheck}></FontAwesomeIcon>
        &nbsp;Finalize
      </Button>
      <Modal show={show}>
        <Modal.Header>
          <Modal.Title>Finalize the invoice</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Do you want to finalize the invoice "#{props.invoice.id}"?
          <Alert variant="danger" hidden={!errorMessage}>
            <b>Unable to delete the invoice: </b>
            <blockquote>{errorMessage}</blockquote>
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" aria-label="Close" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="success"
            aria-label="finalize invoice"
            onClick={finalizeInvoice}
          >
            Finalize
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
